import createVueApp from '@phoenix/createVueApp';
import NewsletterFormModal from '@maison/components/form/NewsletterFormModal.vue';

const app = createVueApp({}, true);
app.component('NewsletterFormModal', NewsletterFormModal);
app.mount('#phoenix-newsletter-form-modal');
